import { Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { ServicesPage } from "./pages/ServicesPage";
import { VoltairePage } from "./pages/VoltairePage";
import { DocumentsPage } from "./pages/DocumentsPage";
import { ClaimStateProvider } from "./state";

export default function App() {
  return (
    <ClaimStateProvider>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/services" replace />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/voltaire" element={<VoltairePage />} />
          <Route path="/documents" element={<DocumentsPage />} />
        </Routes>
      </AppShell>
    </ClaimStateProvider>
  );
}
